import api from '../services/api';
import { IAddress } from '../shared/interfaces';

interface IResponseGetAddress {
  data: IAddress[];
  client_id: string;
  client_name: string;
}
export const getAddress = async (
  client_id: string | undefined,
): Promise<IResponseGetAddress> => {
  if (!client_id) {
    throw new Error('ID do cliente não fornecido.');
  }

  const response = await api.get(`/address/list/${client_id}`);
  return response.data;
};

export const postAddress = async (payload: any): Promise<IAddress> => {
  const response = await api.post(`/address`, payload);
  return response.data;
};

export const patchAddress = async (
  id: string | undefined,
  payload: any,
): Promise<IAddress> => {
  if (!id) {
    throw new Error('ID do endereço não fornecido.');
  }
  const response = await api.patch(`/address/${id}`, payload);
  return response.data;
};
